var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12_139",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0587769,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12_139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.80878 16.0385L16.0973 12L9.80878 7.9615V16.0385ZM12.0605 21.5C10.7465 21.5 9.51144 21.2507 8.35528 20.752C7.19911 20.2533 6.19344 19.5766 5.33828 18.7218C4.48311 17.8669 3.80603 16.8617 3.30703 15.706C2.80819 14.5503 2.55878 13.3156 2.55878 12.0017C2.55878 10.6877 2.80811 9.45267 3.30678 8.2965C3.80544 7.14033 4.48219 6.13467 5.33703 5.2795C6.19186 4.42433 7.19711 3.74725 8.35278 3.24825C9.50844 2.74942 10.7432 2.5 12.057 2.5C13.371 2.5 14.6061 2.74933 15.7623 3.248C16.9184 3.74667 17.9241 4.42342 18.7793 5.27825C19.6344 6.13308 20.3115 7.13833 20.8105 8.294C21.3094 9.44967 21.5588 10.6844 21.5588 11.9983C21.5588 13.3123 21.3094 14.5473 20.8108 15.7035C20.3121 16.8597 19.6354 17.8653 18.7805 18.7205C17.9257 19.5757 16.9204 20.2528 15.7648 20.7518C14.6091 21.2506 13.3744 21.5 12.0605 21.5ZM12.0588 20C14.2921 20 16.1838 19.225 17.7338 17.675C19.2838 16.125 20.0588 14.2333 20.0588 12C20.0588 9.76667 19.2838 7.875 17.7338 6.325C16.1838 4.775 14.2921 4 12.0588 4C9.82544 4 7.93378 4.775 6.38378 6.325C4.83378 7.875 4.05878 9.76667 4.05878 12C4.05878 14.2333 4.83378 16.125 6.38378 17.675C7.93378 19.225 9.82544 20 12.0588 20Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircle);
export default __webpack_public_path__ + "static/media/playCircle.55980ff8e06483e13560e7e6fd366b63.svg";
export { ForwardRef as ReactComponent };